import { useConnection } from "@solana/wallet-adapter-react";
import { HubbleStakingPositionFetcher } from "@stepfinance/staking";
import { useQuery } from "@tanstack/react-query";
import { useEffect, useMemo } from "react";

import { useEnrichedWallet } from "../../contexts/enrichedWallet";
import { useMarkets } from "../../contexts/market";
import { useRefreshContext } from "../../contexts/refresh";

export const useHubbleStaking = () => {
  const { connection } = useConnection();
  const { publicKey } = useEnrichedWallet();
  const { marketsInitialised, priceInUSD } = useMarkets();
  const { refreshID } = useRefreshContext();

  const hubbleStakingFetcher = useMemo(() => {
    if (publicKey && marketsInitialised) {
      return new HubbleStakingPositionFetcher({ connection, publicKey });
    }
  }, [connection, marketsInitialised, publicKey]);

  const { data, refetch } = useQuery(
    ["hubble-staking", publicKey?.toBase58()],
    async () => {
      if (hubbleStakingFetcher && priceInUSD && publicKey) {
        return await hubbleStakingFetcher.fetchPositions(priceInUSD);
      }
      return [];
    },
    { retry: false, enabled: hubbleStakingFetcher !== undefined },
  );

  useEffect(() => {
    void refetch();
  }, [refetch, refreshID, hubbleStakingFetcher]);

  return data || [];
};
